export enum WhitelabelImage {
  GENERAL_SUCCESS = 'general-success',
  WAITING = 'waiting',
  REGISTRATION_SUCCESS = 'registration-success',
  ERROR = 'error',
  PASSWORD_RESET = 'pw-reset',
  SEARCHING = 'searching',
  MAIL = 'mail',
  ORDER_PLACED = 'order-placed',
  UNAUTHORIZED = 'guard-dog',
  ADDRESS_CHANGE = 'address-change',
  EMAIL_SENT = 'email-sent',
  DOCUMENTS = 'documents',
  DOWNTIME = 'downtime',
  CHAT_BOT = 'chat-bot',
  WELCOME = 'welcome',
  CONTACT = 'contact',
  POINTING = 'pointing',
  BOTTLE_MESSAGE = 'bottle-message',
  OFFLINE = 'offline',
}

export enum WhitelabelImageType {
  PNG = 'png',
  SVG = 'svg',
  GIF = 'gif',
}

export enum WhitelabelImageAltTag {
  GENERAL_SUCCESS = 'a11y_alt_tag.success_l',
  WAITING = 'a11y_alt_tag.waiting_l',
  REGISTRATION_SUCCESS = 'a11y_alt_tag.registration_success_l',
  ERROR = 'a11y_alt_tag.error_l',
  PASSWORD_RESET = 'a11y_alt_tag.pw_reset_l',
  SEARCHING = 'a11y_alt_tag.searching_l',
  MAIL = 'a11y_alt_tag.mail_l',
  ORDER_PLACED = 'a11y_alt_tag.order_placed_l',
  UNAUTHORIZED = 'a11y_alt_tag.unauthorized_l',
  ADDRESS_CHANGE = 'a11y_alt_tag.address_change_l',
  EMAIL_SENT = 'a11y_alt_tag.email_sent_l',
  DOCUMENTS = 'a11y_alt_tag.documents_l',
  CONTACT = 'a11y_alt_tag.contact_l',
  WELCOME = 'a11y_alt_tag.welcome_l',
  POINTING = 'a11y_alt_tag.pointing_l',
  BOTTLE_MESSAGE = 'a11y_alt_tag.bottle_message_l',
}
